import { type NavItemType } from '../../components/nav/navItem';

export const navItems: NavItemType[] = [
  {
    text: 'home',
    emoji: '🤍',
    url: '',
    target: '_self',
  },
  {
    text: 'about me',
    emoji: '👀',
    url: 'me',
    target: '_self',
  },
  {
    text: 'CV',
    emoji: '📖',
    url: 'cv',
    target: '_self',
  },
  {
    text: 'projects',
    emoji: '💾',
    url: 'projects',
    target: '_self',
  },
  {
    text: 'timeline',
    emoji: '🧭',
    url: 'timeline',
    target: '_self',
  },
  {
    text: 'github',
    emoji: '💻',
    url: 'https://www.github.com/magnusouren',
    target: '_blank',
  },
  {
    text: 'linkedin',
    emoji: '🔗',
    url: 'https://www.linkedin.com/in/magnus-tomter-ouren-44a80321b/',
    target: '_blank',
  },
  {
    text: 'email',
    emoji: '✉️',
    url: 'mailto:magnut0203@gmail.com',
    target: '_self',
  },
];
